/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminResetPasswordRequest
 */
export interface AdminResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminResetPasswordRequest
     */
    email: string;
}

/**
 * Check if a given object implements the AdminResetPasswordRequest interface.
 */
export function instanceOfAdminResetPasswordRequest(value: object): value is AdminResetPasswordRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function AdminResetPasswordRequestFromJSON(json: any): AdminResetPasswordRequest {
    return AdminResetPasswordRequestFromJSONTyped(json, false);
}

export function AdminResetPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminResetPasswordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function AdminResetPasswordRequestToJSON(json: any): AdminResetPasswordRequest {
    return AdminResetPasswordRequestToJSONTyped(json, false);
}

export function AdminResetPasswordRequestToJSONTyped(value?: AdminResetPasswordRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

